import { FormErrors } from 'redux-form';
import { calculateAge, rutValidator } from '../helpers/utils';
import { IEmitForm } from '../store/Emit';

const regexDate = /^((0?[1-9]|[12][0-9]|3[01])[- /.](0?[1-9]|1[012])[- /.](19|20)?[0-9]{2})*$/i;
const regexString = /^[A-Za-zÀ-ÿÑñ\-' ]+$/i;

const validation = (values: IEmitForm) => {
  const errors: FormErrors<any> = {};

  if (!values.documentId) {
    errors.documentId = 'Campo obligatorio';
  } else if (!rutValidator(values.documentId)) {
    errors.documentId = 'Rut inválido';
  }

  if (!values.birthdate) {
    errors.birthdate = 'Campo obligatorio';
  } else if (!regexDate.test(values.birthdate)) {
    errors.birthdate =
      'Formato de fecha inválido, el formato es dd-mm-aaaa.';
  } else if (calculateAge(values.birthdate).years >= 60) {
    errors.birthdate =
      'Edad máxima de ingreso al seguro es de 59 años y 364 días.';
  } else if (calculateAge(values.birthdate).years < 18) {
    errors.birthdate =
      'Para contratar este seguro debes ser mayor de 18 años de edad.';
  }
  if (!values.name) {
    errors.name = 'Campo obligatorio';
  } else if (!regexString.test(values.name)) {
    errors.name =
      'El nombre no puede contener números ni caracteres especiales, solo letras';
  } else if (values.name.length > 50) {
    errors.name = 'El nombre solo puede contener un máximo de 50 caracteres';
  }

  if (!values.paternal) {
    errors.paternal = 'Campo obligatorio';
  } else if (!regexString.test(values.paternal)) {
    errors.paternal =
      'El apellido no puede contener números ni caracteres especiales, solo letras';
  } else if (values.paternal.length > 50) {
    errors.paternal =
      'El apellido solo puede contener un máximo de 50 caracteres';
  }

  if (!values.maternal) {
    errors.maternal = 'Campo obligatorio';
  } else if (!regexString.test(values.maternal)) {
    errors.maternal =
      'El apellido no puede contener números ni caracteres especiales, solo letras';
  } else if (values.maternal.length > 50) {
    errors.maternal =
      'El apellido solo puede contener un máximo de 50 caracteres';
  }

  if (!values.gender) {
    errors.gender = 'Debe seleccionar su género';
  }

  return errors;
};

export default validation;
